<template>
  <div class="archive">
    <div class="archiveContainer">
      <div class="containerHeader">
        <h1 class="headerTitle">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path
              d="M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
            />
          </svg>
          <span>آرشیو سرویس ها</span>
        </h1>
      </div>
      <div class="containerMain">
        <div class="mainList" v-if="ServiceList.length > 0 && !loading">
          <div
            class="listThumb"
            v-for="(ServiceLists, index) in ServiceList"
            :key="index"
          >
            <div class="thumbHeader">
              <div class="headerNum">{{ ServiceLists.service_id }}</div>
              <div class="headerDate">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
                  />
                </svg>
                <span>{{ ServiceLists.service_date }}</span>
              </div>
            </div>
            <div class="thumbMain">
              <div class="mainPaymentNum">
                مبلغ {{ ServiceLists.amount }} تومان
              </div>
              <div class="mainPaymentMeth">
                پرداخت {{ ServiceLists.payment_method }}
              </div>
              <div class="mainDriver">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  class="size-5"
                >
                  <path
                    fill-rule="evenodd"
                    d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-5.5-2.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM10 12a5.99 5.99 0 0 0-4.793 2.39A6.483 6.483 0 0 0 10 16.5a6.483 6.483 0 0 0 4.793-2.11A5.99 5.99 0 0 0 10 12Z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>{{ ServiceLists.nickname }}</span>
              </div>
            </div>
            <div class="thumbFooter">
              <router-link
                :to="{
                  name: 'detailService',
                  params: { id: ServiceLists.service_id },
                }"
                class="deatilsBtn"
                >جزئیات</router-link
              >
            </div>
          </div>
        </div>
        <div class="noResultWrapper" v-if="ServiceList.length == 0 && !loading">
          <div class="noResultThumb">
            <img
              src="@/assets/img/notfound.png"
              alt="Alt text"
              width="320"
              height="280"
            />
          </div>
        </div>
        <div class="mainList" v-if="ServiceList.length == 0 && loading">
          <div class="listThumbSk skeleton-box" v-for="i in 2" :key="i"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import { PerfectScrollbar } from "vue3-perfect-scrollbar";

export default {
  components: {
    // PerfectScrollbar,
  },
  data() {
    return {
      dropArea: null,
      branch_select: 0,
      BtnSelect1: "border-bottom: 2px solid #68A1FF;",
      BtnSelect2: "",
      userBox: [],
      ServiceList: [],
      step: 1,
      PageShow: 0,
      PageShow1: 0,
      time: "",
      loadmore: false,
      loading: true,
    };
  },
  mounted() {
    let self = this;
    self.dropArea = document.getElementById("drop-area");
  },
  watch: {
    auth_taxi(newVal) {
      if (newVal) {
        this.userBox = newVal;
        this.getInfo();
        this.userMethod();
      }
    },
  },
  computed: {
    ...mapGetters(["auth_taxi"]),
  },
  methods: {
    getInfo() {
      this.userBox = this.auth_taxi;
    },
    branch_select_func() {
      let self = this;
      if (self.branch_select == null) {
        self.branch_select = 0;
      }
      self.userMethod("filter");
    },
    userMethod(param) {
      this.loadmore = true;
      this.PageShow += 1;
      if (param == "filter") {
        this.loading = true;
        this.ServiceList = [];
        this.PageShow = 1;
      }

      this.helperGet_taxi(
        "customer-service-list",
        "uid=" +
          this.auth_taxi.uid +
          "&list_type=all" +
          "&page=" +
          this.PageShow
      ).then((json) => {
        console.log("json", json);
        if (json.data.result == 0) {
          this.ServiceList = [];
          if (param != "filter") {
            this.PageShow -= 1;
          }
        } else {
          this.ServiceList = this.ServiceList.concat(json.data.data.list);
          if (json.data.data.total_page === this.PageShow) {
            this.loadmore = false;
          }
        }
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.archive {
  width: 100%;
  min-height: 100vh;
  padding: 90px 0 66px;
  position: relative;
  direction: rtl;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  background: #fff;

  .archiveContainer {
    position: relative;
    .containerHeader {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 999;
      background: #fff;
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);
      padding: 20px 16px;
      max-width: 550px;
      margin-left: auto;
      margin-right: auto;

      .headerTitle {
        display: flex;
        align-items: center;
        gap: 8px;

        svg {
          width: 24px;
          height: 24px;
          stroke-width: 2.5;
          fill: #0851a0;
        }

        span {
          font-family: "yekan", sans-serif;
          font-size: 1.15rem;
          font-weight: 700;
          color: #000;
        }
      }
    }

    .containerMain {
      width: 90%;
      margin-left: auto;
      margin-right: auto;

      .mainList {
        width: 100%;

        .listThumb {
          width: 100%;
          border-radius: 10px;
          background: #f7f7f7;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
          border: 1px solid #dedede;
          padding: 16px;
          margin-bottom: 24px;

          .thumbHeader {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 4px;

            .headerNum {
              font-family: "yekan", sans-serif;
              font-size: 1.75rem;
              color: #0851a0;
              font-weight: 800;
            }

            .headerDate {
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 4px;
              color: #949494;

              svg {
                width: 16px;
                height: 16px;
              }

              span {
                font-size: 0.85rem;
              }
            }
          }

          .thumbMain {
            width: 100%;
            margin-bottom: 16px;

            .mainPaymentNum {
              font-size: 1.1rem;
              margin-bottom: 6px;
              color: #000;
            }

            .mainPaymentMeth {
              margin-bottom: 0.95rem;
              color: #555;
              margin-bottom: 12px;
            }

            .mainDriver {
              color: #777;
              display: flex;
              align-items: center;
              gap: 4px;

              svg {
                width: 28px;
                height: 28px;
              }

              span {
                color: #000;
                font-size: 1rem;
              }
            }
          }

          .thumbFooter {
            .deatilsBtn {
              width: 100%;
              height: 42px;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #0851a0;
              color: #fff;
              font-family: "iranyekanB", sans-serif;
              font-size: 0.95rem;
              border-radius: 10px;
            }
          }
        }
      }
    }
  }
}

.noResultThumb {
  display: flex;
  justify-content: center;
}

.listThumbSk {
  width: 100%;
  height: 212px;
  border-radius: 10px;
  margin-bottom: 16px;
}
</style>
